var render, staticRenderFns
import script from "./OLinkCell.vue?vue&type=script&lang=js&"
export * from "./OLinkCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40112c34",
  null
  
)

export default component.exports